<header class="mast-main-head fixed-top" *ngIf="mobileViewSection">
  <nav class="navbar navbar-expand-lg remove-shadow" id="mainNav">
    <div class="container left-header-subscribe">
      <a class="navbar-brand js-scroll-trigger" routerLink="/home"><img src="assets/img/logo.svg"></a>
    </div>
  </nav>
</header>

<header class="masthead" *ngIf="!mobileViewSection">
	<div class="navbar">
		<div class="left-header" style="margin-left: 12px; position: relative">
				<button style="width: 260px;" id="create-workspace" class="back-to-workspace" data-toggle="dropdown" class="DAM-icon">
					<a (click)="backToWorkspace()" class="navbar-brand js-scroll-trigger left-header-backpress" href="javascript:;"><svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
					    <title>Back</title>
					    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
					        <g id="DAM-Pricing-Copy-2" transform="translate(-40.000000, -28.000000)">
					            <g id="Back" transform="translate(40.000000, 28.000000)">
					                <rect id="Rectangle-8" x="0" y="0" width="24" height="24"></rect>
					                <g id="Group-7" stroke-linecap="round" stroke-linejoin="round" transform="translate(3.000000, 6.000000)" stroke="#000000" stroke-width="1.5">
					                    <line x1="0" y1="6" x2="17.1428571" y2="6" id="Stroke-1"></line>
					                    <polyline id="Path-2" points="5.4 0 0 5.9256575 5.27460736 12"></polyline>
					                </g>
					            </g>
					        </g>
					    </g>
					</svg>
				</a>
				<div class="lib-icon-blue">
					<img src="assets/img/workspace.svg">
				</div>
				<h4 class="content-lib-txt">Workspaces</h4>
			</button>
		</div>

		<!-- <div class="workspace-left-header">
      <a class="navbar-brand js-scroll-trigger" href="javascript:;" routerLink="/home">
        <img src="assets/img/logo.svg"></a>
        <p (click)="backToWorkspace()">Back to Workspace</p>
    </div> -->

		<div class="right-header">
      <div class="menu-pop-over anticon-bell">
				<a href="javascript:;" class="upgrade-txt" (click)="showUpgradePlans()" *ngIf="userRole == 'Owner' || userRole == 'Admin'">Upgrade</a>
			</div>

			<div class="figma-icons-section">
        <div class="plugin-figma-icon">
          <button (click)="openFigma()" id="notification-pop-over" data-toggle="dropdown" class="anticon-bell-icon">
            <img src="assets/img/ic-figma.png">
          </button>
        </div>

        <div class="plugin-sketch-icon">
          <button (click)="openSketch()" id="notification-pop-over" data-toggle="dropdown" class="anticon-bell-icon">
            <img src="assets/img/ic-sketch.png">
          </button>
        </div>

        <div class="plugin-ai-icon">
          <button (click)="openIllustrator()" id="notification-pop-over" data-toggle="dropdown" class="anticon-bell-icon">
            <img src="assets/img/ai.png" style="width: 20px; height: 20px;">
          </button>
        </div>
      </div>

			<div class="menu-pop-over anticon-bell">
				<button id="notification-pop-over" data-toggle="dropdown" class="anticon-bell-icon" (click)="getNotifications()">
					<img src="assets/img/ic-noti.svg">
				</button>
				<!-- <span class="dot"></span> -->
				<div class="dropdown-menu notification-area" aria-labelledby="notification-pop-over">
						<div class="dropdown-container">
							<h5 class="notification-txt" style="margin-bottom:20px;"><b>Notifications</b></h5>
							<div class="notification-item">

								<div *ngIf="notifications.length == 0" class="empty-notification-area">
									<img src="assets/img/no-noti.svg" alt="">
									<span>You have no notifications</span>
								</div>

								<ul *ngFor="let noti of notifications" style="padding: 0px;">
									<li style="border-bottom: 1px solid rgba(0,0,0,0.1);padding: 16px 0 16px 0;margin: 0 16px;">
										<div class="user-details-info">
										<div class="user-img">
											<span class="ant-avatar ant-avatar-circle ant-avatar-image ant-avatar-icon" style="width: 40px; height: 40px; line-height: 40px; font-size:18px; font-weight: 500;">
												<div class="email-initial-setup" [style.background-color]="getRandomColor()">
													{{getName(noti.firstName)}}{{getName(noti.lastName)}}
												</div>
											</span>
										</div>
										<div>
											<div class="user-info-name">
												<span>{{noti.message}} <b>{{noti.firstName}} {{noti.lastName}}</b></span>
											</div>
											<div class="" style="margin-top: 4px;">
												<span class="notification-date">{{noti.timestamp.toString().split(".")[0]}}</span>
											</div>
										</div>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>

			<div class="menu-pop-over user-name" *ngIf="currentUser  && !mobileView">
				<button id="user-pop-over" data-toggle="dropdown" class="user-icon-btn">
					<img *ngIf="!userPic" src="assets/img/user-profile.svg">
					<img *ngIf="userPic" src="{{userPic}}">
				</button>
				<div class="dropdown-menu" aria-labelledby="user-pop-over">
					<div class="dropdown-container">
						<div class="upper-container">
							<div class="name-pro">
								<h6>{{currentUser.firstName+" "+currentUser.lastName}}</h6>
								<span class="pro">
									{{planName}}
								</span>
							</div>
							<div class="email">{{currentUser.email}}</div>
              <div *ngIf="totalSpaceAllowed <= 1000 && consumedSpaceAllowed <= 1000" class="storage-size">{{consumedSpaceAllowed | number: '1.2-2'}}MB / {{totalSpaceAllowed}}GB</div>
              <div *ngIf="totalSpaceAllowed <= 1000 && consumedSpaceAllowed > 1000" class="storage-size">{{consumedSpaceAllowed/1000 | number: '1.2-2'}}GB / {{totalSpaceAllowed}}GB</div>
							<div *ngIf="totalSpaceAllowed > 1000 && consumedSpaceAllowed > 1000" class="storage-size">{{consumedSpaceAllowed/1000 | number: '1.2-2'}}GB / {{totalSpaceAllowed/1000}}TB</div>
							<progress id="file" value="{{consumedSpaceAllowed}}" max="{{totalSpaceAllowedProgress}}"></progress>
						</div>

						<ul class="dropdown-list list-group">
							<div class="hr-line"></div>
							<a routerLink="/my-profile"><li class="list-group-item">My profile</li></a>
							<a (click)="personalClick()"><li class="list-group-item">My content hub</li></a>
							<div class="hr-line"></div>
							<a routerLink="/how-it-works" target="_blank"><li class="list-group-item">How it works</li></a>
							<a routerLink="/home" target="_blank"><li class="list-group-item">Go to Homepage</li></a>
							<a (click)="goToMarketplace()"><li class="list-group-item">Go to Marketplace</li></a>
							<a (click)="goToFeedback()"><li class="list-group-item">Feedback & bugs report</li></a>
							<a routerLink="/faq" target="_blank"><li class="list-group-item">FAQ</li></a>
              <a (click)="goProClick()" *ngIf="planName == 'Free'">
								<li class="list-group-item" style="background-color: var(--primaryColorLightBlue); border-radius: 4px; margin-top: 8px; display: block;"><b style="color: #2d7cff">Upgrade plan:</b><span> You're on the free plan. Upgrade now for unlimited storage, access, members, and more.</span></li>
							</a>
						</ul>
						<div class="logout-btn">
							<button type="button" class="ant-btn" (click)="logOut()"><a>Logout</a></button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</header>

<section class="workspace-screen" *ngIf="!mobileViewSection">
  <div class="background container-fluid">
    <div class="container main-heading">
      <h3>Your workspaces</h3>
      <p>Hello! You are signed in as {{currentUser.email}}</p>
      <div class="google-login-btn">
				<div class="">
					<ul *ngFor="let workspace of workspaces">
	          <li (click)="launchWorkspace(workspace.title, workspace.id, workspace.role)">
							<div class="select-workspace-section" style="display: flex;">
								<div class="user-img" *ngIf="workspaceName != workspace.title">
									<b>{{getInitials(workspace.title)}}</b>
								</div>
								<div class="" *ngIf="workspaceName === workspace.title">
									<span class="ant-avatar-selected">
										<svg width="16" height="12" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M1 5L4.58824 9L13 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
										</svg>
									</span>
								</div>
		            <h4>{{workspace.title}}
		            </h4>
							</div>
	            <hr>
	          </li>
	        </ul>
				</div>
        <button class="launch-workspace-create-button-disable" type="button" name="button" *ngIf="workspaces.length == workspaceCountAllowed">Create Workspace</button>
        <button class="launch-workspace-create-button" type="button" name="button" (click)="openNewWorkspaceDialog()" *ngIf="workspaces.length != workspaceCountAllowed">Create Workspace</button>
        <button type="button" name="button" class="launch-workspace-workspace-quota" *ngIf="workspaces.length == workspaceCountAllowed">Workspace limit reached</button>
        <p style="font-size: 12px;" class="total-workspace-count" *ngIf="workspaceCount == '1'"><i>{{workspaceCount}} workspace total</i></p>
        <p style="font-size: 12px;" class="total-workspace-count" *ngIf="workspaceCount > '1'"><i>{{workspaceCount}} workspaces total</i></p>
      </div>
    </div>
    <!-- <div class="footer-chat">
			<span class="chat-bg">
				<span class="chat-icon"></span>
			</span>
		</div> -->
  </div>
</section>

<section class="mobile-view-section" *ngIf="mobileViewSection">
	<div class="container">
		<div class="row">
		  <img src="assets/img/laptop.svg" alt="">
		  <div class="text-container">
		    <h4>Switch to Desktop</h4>
		    <p>Crafttor Workspace is best experienced on desktop. To proceed, Log in from a desktop browser.</p>
		  </div>
		</div>
	</div>
</section>

<div
	style="width: 100%;
	background-color: rgba(0,0,0, .9);
	padding-top: 150px;"
	class="modal"
	tabindex="-1"
	role="dialog"
	[ngStyle]="{'display':createWorkspaceStyle}">
	<div class="modal-dialog-style modal-dialog-centered-style" role="document" style="height: 100px;
    width: 35%; margin: 0 auto; text-align: center;">
		<div class="modal-content" style="position: relative; padding: 30px; background-color: rgb(255,255,255); border-radius: 10px;">
			<div class="modal-body new-create-workspace-dialog">
				<button style="margin: -10px;" type="button" class="close" (click)="closeNewWorkspaceDialog()" data-dismiss="modal" aria-label="Close">
					<img src="assets/img/cross.svg">
				</button>
				<div class="mt-2 share-class-permit">
					<div class="inner-content welcome-txt" style="background-color: #fff">
						<h6>Create Workspace</h6>
						<p class="create-space-p">Create and customise a workspace as per your requirements.</p>
						<div class="create-workspace-txt">
							<p>Name Workspace</p>
						</div>
						<div class="btn-wrapper">
							<form style="width: 100%" class="form-horizontal" [formGroup]="createWorkspaces" (ngSubmit)="createWorkspace(workspaceNames.value)">
								<input maxlength="50" formControlName="message" placeholder="Your workspace name" data-test-name="invite-email-input" class="workspace-ant-input-invite-field" type="text" value="" #workspaceNames>
							</form>
						</div>
						<span class="text-danger error-text board-error-text" *ngIf="isShowCreateWorkspaceError">{{createWorkspaceErrorMessage}}</span>
						<span class="text-danger error-text board-error-text" *ngIf="isShowCreateLoginWorkspaceError" style="cursor: pointer;"><b>{{createWorkspaceLoginErrorMessage}}</b></span>
						<button *ngIf="!showLeaveLoader" style="width: 100%" [disabled]="workspaceNames.value === ''" data-test-name="send-invite-button" type="button" class="ant-btn-create-org ant-btn-default ant-input-search-button" (click)="createWorkspace(workspaceNames.value)"><span role="img" aria-label="plus" class="create-workspace-span">Create Workspace</span></button>

						<button *ngIf="showLeaveLoader" style="width: 100%" data-test-name="send-invite-button" type="button" class="ant-btn-create-org ant-btn-default ant-input-search-button">
							<img class="img-up-loader" style="height: 18px;" src="assets/img/img-up-white.svg" alt="">
						</button>

						<button type="button" name="button" class="new-workspace-cancel" (click)="closeNewWorkspaceDialog()">Cancel</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
